import { render } from "./bellLogPage.vue?vue&type=template&id=456a37d0&scoped=true"
import script from "./bellLogPage.vue?vue&type=script&lang=js"
export * from "./bellLogPage.vue?vue&type=script&lang=js"

import "./bellLogPage.vue?vue&type=style&index=0&id=456a37d0&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-456a37d0"]])

export default __exports__